var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-sort-item"},[_c('div',{staticClass:"ws-sort-item__text",class:{'ws-sort-item__error': _vm.error}},[_vm._t("default")],2),_c('v-icon',{staticClass:"icon-margin",attrs:{"size":28}},[_vm._v("mdi-drag-vertical ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }